(() => {
  if (!window.KGBundle) window.KGBundle = {};
  const KGBundle = window.KGBundle;

//   function parseBundleChildren(form) {
//     const productFormEl = form.closest("product-form");
//     if (!productFormEl) return [];
//     const raw = productFormEl.dataset.bundleChildren;
//     if (!raw) return [];

//     try {
//       const parsed = JSON.parse(raw);
//       if (!Array.isArray(parsed)) return [];
//       return parsed
//         .map((entry) => {
//           if (typeof entry === "number" || typeof entry === "string") {
//             return { id: entry, quantity: 1 };
//           }
//           if (entry && entry.id) {
//             return {
//               id: entry.id,
//               quantity: entry.quantity || 1,
//             };
//           }
//           return null;
//         })
//         .filter(Boolean);
//     } catch (e) {
//       console.warn("KGBundle: invalid bundle children data", e);
//       return [];
//     }
//   }

//   function ensureBundleGroup(form, formData, hasChildren) {
//     if (!hasChildren) return null;

//     let groupId = form.dataset.kgBundleGroup;
//     if (!groupId) {
//       groupId =
//         Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
//       form.dataset.kgBundleGroup = groupId;
//     }

//     if (formData && !formData.has("properties[_kg_bundle_group]")) {
//       formData.append("properties[_kg_bundle_group]", groupId);
//     }
//     if (formData && !formData.has("properties[_kg_bundle_role]")) {
//       formData.append("properties[_kg_bundle_role]", "parent");
//     }

//     return groupId;
//   }

//   KGBundle.beforeProductFormSubmit = function (form, formData) {
//     const children = parseBundleChildren(form);
//     if (!children.length) return;
//     ensureBundleGroup(form, formData, true);
//   };

//   KGBundle.afterProductAdded = function (form, mainVariantId) {
//     const children = parseBundleChildren(form);
//     if (!children.length) return;

//     const groupId = form.dataset.kgBundleGroup;
//     if (
//       !groupId ||
//       typeof routes === "undefined" ||
//       !routes.cart_add_url
//     )
//       return;
//     if (typeof fetchConfig !== "function") return;

//     const items = children.map((child) => ({
//       id: child.id,
//       quantity: child.quantity || 1,
//       properties: {
//         _kg_bundle_group: groupId,
//         _kg_bundle_role: "child",
//         _kg_bundle_parent_variant: String(mainVariantId || ""),
//       },
//     }));

//     if (!items.length) return;

//     const config = fetchConfig();
//     config.body = JSON.stringify({ items });

//     fetch(routes.cart_add_url, config)
//       .then(() => {
//         if (document.querySelector("cart-drawer")) {
//           document.dispatchEvent(
//             new CustomEvent("cart-drawer:refresh", { bubbles: true }),
//           );
//         }
//       })
//       .catch((e) => {
//         console.error("KGBundle: error adding child items", e);
//       });
//   };

  KGBundle._pendingRemovalGroupId = null;

  KGBundle.beforeCartUpdate = function ({ cartComponent, line, quantity }) {
    if (!cartComponent || quantity !== 0) return;

    const lineItem =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`);
    if (!lineItem) return;

    const role = lineItem.dataset.bundleRole;
    const group = lineItem.dataset.bundleGroup;
    if (role === "parent" && group) {
      KGBundle._pendingRemovalGroupId = group;
    }
  };

  KGBundle.onCartChange = function ({ cartComponent, parsedState }) {
    const groupId = KGBundle._pendingRemovalGroupId;
    if (!cartComponent || !groupId || !parsedState || !parsedState.items) {
      return;
    }

    KGBundle._pendingRemovalGroupId = null;

    if (KGBundle._removingBundleChildren) return;
    KGBundle._removingBundleChildren = true;

    const childKeys = parsedState.items
      .map((item) => {
        const props = item.properties || {};
        const itemGroup = props.__bundle_group || props._kg_bundle_group;
        const itemRole = props.__bundle_role || props._kg_bundle_role;
        if (
          itemGroup === groupId &&
          itemRole === "child" &&
          item.quantity > 0 &&
          item.key
        ) {
          return item.key;
        }
        return null;
      })
      .filter((v) => v !== null)
      .reverse();

    const removeNext = () => {
      const key = childKeys.shift();
      if (!key) {
        KGBundle._removingBundleChildren = false;
        return;
      }

      if (typeof routes === "undefined" || !routes.cart_change_url || typeof fetchConfig !== "function") {
        KGBundle._removingBundleChildren = false;
        return;
      }

      const sectionsToRender =
        typeof cartComponent.getSectionsToRender === "function"
          ? cartComponent.getSectionsToRender()
          : [];

      const body = JSON.stringify({
        id: key,
        quantity: 0,
        sections: sectionsToRender.map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((r) => r.text())
        .then((state) => {
          const nextState = JSON.parse(state);
          if (nextState && nextState.sections && sectionsToRender.length) {
            sectionsToRender.forEach((section) => {
              const elementToReplace =
                (document.getElementById(section.id) &&
                  document
                    .getElementById(section.id)
                    .querySelector(section.selector)) ||
                document.getElementById(section.id);
              if (!elementToReplace) return;

              if (typeof cartComponent.getSectionInnerHTML === "function") {
                elementToReplace.innerHTML =
                  cartComponent.getSectionInnerHTML(
                    nextState.sections[section.section],
                    section.selector,
                  ) || "";
              } else {
                elementToReplace.innerHTML = nextState.sections[section.section] || "";
              }
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(removeNext, 50);
        });
    };

    removeNext();
  };
})();



const products = document.querySelectorAll(".kg-subscription__product");

function kgUpdateBundlePrice() {

    let bundlePrice = 0;
    let subscriptionPrice = 0;

    products.forEach((product) => {

        const variantSelect = product.querySelector(".kg-subscription__variant-select");
        const planSelect = product.querySelector(".kg-subscription__plan-select");

        const data = JSON.parse(
            product.querySelector(".kg-subscription__product-data").textContent
        );

        const variantId = parseInt(variantSelect.value);

        const variant = data.variants.find(v => v.id === variantId);

        if (!variant) return;

        bundlePrice += variant.price;

        const planId = planSelect ? parseInt(planSelect.value) : null;
        const plan = variant.plans.find(p => p.id === planId);

        if (plan) {

            const deliveries = plan.interval || 1;

            const pricePerDelivery = plan.price / deliveries;

            subscriptionPrice += pricePerDelivery;

        } else {

            subscriptionPrice += variant.price;

        }

    });

    const savings = bundlePrice - subscriptionPrice;

    const discount = bundlePrice
    ? Math.round(((bundlePrice - subscriptionPrice) / bundlePrice) * 100)
    : 0;

    const priceEl = document.getElementById("kg-bundle-price");
    const savingsEl = document.getElementById("kg-bundle-savings");
    // const discountEl = document.getElementById("kg-bundle-discount");
console.log({
  bundlePrice,
  subscriptionPrice,
  savings,
  discount
});
    if (priceEl) {
        priceEl.innerHTML =
        kgFormatMoney(subscriptionPrice) +
            ' <span class="kg-subscription__price-month text-small">/mes</span>';

        document.querySelector(".wt-cta-add__price").innerHTML = kgFormatMoney(subscriptionPrice);
    }

    if (savingsEl) {
        savingsEl.innerText = kgFormatMoney(savings);
    }

    // if (discountEl) {
    //     discountEl.innerText = "-" + discount + "%";
    // }

}

products.forEach((product) => {

    const variantSelect = product.querySelector(".kg-subscription__variant-select");
    const planSelect = product.querySelector(".kg-subscription__plan-select");

    const data = JSON.parse(
        product.querySelector(".kg-subscription__product-data").textContent
    );

    if (variantSelect) {

        variantSelect.addEventListener("change", function () {

            const variantId = parseInt(this.value);
            const variant = data.variants.find(v => v.id === variantId);

            if (!variant) return;

            if (planSelect) {

                planSelect.innerHTML = "";

                let cheapestPlan = null;

                variant.plans.forEach((plan) => {

                const option = document.createElement("option");
                option.value = plan.id;
                option.textContent = plan.name;

                planSelect.appendChild(option);

                if (!cheapestPlan || plan.price < cheapestPlan.price) {
                    cheapestPlan = plan;
                }

                });

                if (cheapestPlan) {
                planSelect.value = cheapestPlan.id;
                }

                planSelect.disabled = variant.plans.length <= 1;

            }

            kgUpdateBundlePrice();

        });

    }

    if (planSelect) {
        planSelect.addEventListener("change", kgUpdateBundlePrice);
    }

});

function kgFormatMoney(cents) {
  return new Intl.NumberFormat(window.Shopify?.locale || 'en', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);
}

function kgGetSubscriptionItems() {

  const items = [];

  const checkedRadio = document.querySelector(
    '.subscription-selector-native input[type="radio"]:checked'
  );
  const isOneTime =
    checkedRadio && checkedRadio.dataset.radioType === "one_time_purchase";

  const variantSelects = document.querySelectorAll(".kg-subscription__variant-select");
  const planSelects = document.querySelectorAll(".kg-subscription__plan-select");

  variantSelects.forEach((variantSelect, index) => {

    const planSelect = planSelects[index];

    const variantId = parseInt(variantSelect.value);
    const sellingPlanId = !isOneTime && planSelect ? parseInt(planSelect.value) : null;

    const item = {
      id: variantId,
      quantity: 1
    };

    if (sellingPlanId) {
      item.selling_plan = sellingPlanId;
    }

    items.push(item);

  });

  return items;
}